<section class="payments-method">
  <h3 class="payments-title"> Payment method</h3>

  <div class="select-std-pay-meth" id="select-std-paymentmethod">
    <div class="payment-info" [ngbPopover]=popoverExpiryDefaultCard placement="top" #defaultCard="ngbPopover"
      triggers="manual" popoverClass="savedordermini-popover expirysixmonths-popover card-default">

      <ng-template #popoverExpiryDefaultCard>
        <div class="card-expiry-six-months">
          <img class="warning-icon" src="../../../../assets/icons/{{baseSiteId}}/warning_red_new.png" alt="" />
          <span class="card-expiry-six-months-text">Card Expires within 6 months</span>
        </div>
      </ng-template>
      <div *ngIf="!orderFlu">
        <ng-select class="w-100 payment-details" *ngIf="hidePaymentMethod===false else onlyBillMeLater"
          [items]="paymentMethodsArray" bindLabel="name" bindValue="code" [multiple]="false" name="chosenPaymentMethod"
          [clearable]="false" placeholder="Select Payment Method" [(ngModel)]="chosenPaymentMethod"
          (change)="getPaymentDetailsOfUser($event)" [dropdownPosition]="bottom"
          [disabled]="cancelFluReservation || (editFluReservation && (editPaymentType== 'CARD' || editPaymentType == 'ACCOUNT'))">

          <ng-template ng-footer-tmp class="ng-select-footer">
            <ng-option class="create-new" (click)="redirectToPaymentSettings($event)">
              Manage payment methods
            </ng-option>
          </ng-template>
        </ng-select>


        <ng-template #onlyBillMeLater>
          <span class="billLater-Onsn">{{"orderConfirmation.billMeLater" | cxTranslate }}</span>
        </ng-template>
      </div>
      <div *ngIf="orderFlu" class="row">

        <div class="ff-bold mt1 mb1 cold-md-1 mr-4 payment-icon">
          <img *ngIf="cardDetails && cardDetails!==''" alt="card_icon" src="assets/icons/{{baseSiteId}}/check.svg">
          <img *ngIf="cardDetails==undefined || cardDetails ==''" alt="bill_icon"
            src="assets/icons/{{baseSiteId}}/billing.png">
        </div>
        <div class="ff-bold mt1 mb1 col-md-10 col-xs-6 col-sm-6 payment-type">
          <span>{{paymentMethod}}</span><br />
          <!-- <span>DISC (* ending with 0666)</span> -->
          <span *ngIf="cardDetails && cardDetails!=='' && paymentMethod!='Bill me later'"
            class="ff-bold mt1 mb1 ml-2">{{cardDetails}}</span>
          <!-- <span *ngIf="cardDetails && cardDetails!==''" class="ff-bold mt1 mb1 ml-2">{{cardDetails}}</span> -->
        </div>

      </div>
    </div>
  </div>

  <div *ngIf="!orderFlu" class="cardOrAcc-details">

    <div class="payment-ngSelect-Div card-list"
      *ngIf="chosenPaymentMethod === paybycardEnum || chosenPaymentMethod === paybycard3dpriorEnum"
      [ngbPopover]=popoverExpiry placement="top" #cardp1="ngbPopover" triggers="manual"
      popoverClass="savedordermini-popover expirysixmonths-popover">

      <ng-template #popoverExpiry>
        <div class="card-expiry-six-months">
          <img class="warning-icon" src="../../../../assets/icons/{{baseSiteId}}/warning_red_new.png" alt="" />
          <span class="card-expiry-six-months-text">Card Expires within 6 months</span>
        </div>
      </ng-template>

      <ng-select class="w-100" [items]="userCardDataArray" bindLabel="name" bindValue="code" [multiple]="false"
        name="chosenCard" [clearable]="false" placeholder="Select card" [(ngModel)]="chosenCard"
        (change)="getCardDetailsOfUser($event)" [dropdownPosition]="bottom"
        [disabled]="cancelFluReservation || (editFluReservation && (editPaymentType== 'CARD' || editPaymentType == 'ACCOUNT'))">

        <ng-template ng-footer-tmp class="ng-select-footer" *ngIf="!isAsmUser">
          <ng-option class="create-new" (click)="openMFA()" *ngIf="!isAsmUser">
            Add a New Card
          </ng-option>
        </ng-template>

      </ng-select>

    </div>

    <div class="payment-ngSelect-Div acc-list"
      *ngIf="chosenPaymentMethod === paybycheckEnum || chosenPaymentMethod === paybycheck3dpriorEnum">

      <ng-select class="w-100" [items]="userAccountDataArray" bindLabel="name" bindValue="code" [multiple]="false"
        name="chosenAccount" [clearable]="false" placeholder="Select Account" [(ngModel)]="chosenAccount"
        (change)="getAccountDetailsOfUser($event)" [dropdownPosition]="bottom"
        [disabled]="cancelFluReservation || (editFluReservation && (editPaymentType== 'CARD' || editPaymentType == 'ACCOUNT'))">

        <ng-template ng-footer-tmp class="ng-select-footer">
          <ng-option class="create-new" (click)="openAccountModal($event)">
            Add new Checking account
          </ng-option>
        </ng-template>

      </ng-select>
    </div>

  </div>

  <div class="cards" *ngIf="!orderFlu">
    <a title="Visa">
      <img src="../../../../assets/img/visa.png">
    </a>
    <a title="Mastercard">
      <img src="../../../../assets/img/mastercard.png">
    </a>
    <a title="Discover">
      <img src="../../../../assets/img/discover.png">
    </a>
    <a title="Amex">
      <img src="../../../../assets/img/amex.png">
    </a>

  </div>

  <div class="ff-bold mt1 mb1" *ngIf="!stdCartType">
    Acceptance of this {{orderOrReservation}} is subject to credit review and approval by {{baseSiteId == 'vsh' ?
    'Sanofi' :'VaxServe'}}.
  </div>

  <p class="multiple-Shipments-Msg-Div">
    If your {{orderOrReservation}} contains multiple shipments, please note that you will be charged per shipment.
  </p>

</section>